/**
 * 캘린더 수식 편집기의 순수 논리 (spec 2026-09-18-calendar-properties §14 편집기) — DOM 없음.
 * 식을 실행하지 않는다: 자동 완성의 문맥과 삽입만 계산한다. 테스트는 tests/unit/calendar-formula-logic.test.mjs.
 */

// 서버가 주는 위치는 루네(코드 포인트) 수다 — textarea 의 UTF-16 인덱스로 바꾼다.
export function runeToIndex(s, n) {
    let i = 0;
    let k = 0;
    for (const ch of s) {
        if (k === n) return i;
        i += ch.length;
        k += 1;
    }
    return s.length;
}

export function escapeName(n) {
    return n.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

function inString(text, upto) {
    let open = false;
    for (let i = 0; i < upto; i += 1) {
        const c = text[i];
        if (open && c === '\\') { i += 1; continue; }
        if (c === '"') open = !open;
    }
    return open;
}

// caret 앞이 prop(" 의 열린 문자열이면 속성 문맥, 아니면(문자열 밖) 식별자 접두면 함수 문맥.
export function completionContext(text, caret) {
    const before = text.slice(0, caret);
    const m = /prop\(\s*"((?:[^"\\]|\\.)*)$/i.exec(before);
    if (m) return { kind: 'prop', from: caret - m[1].length, prefix: m[1].replace(/\\(.)/g, '$1') };
    if (inString(text, caret)) return null;
    const w = /[A-Za-z_][A-Za-z0-9_]*$/.exec(before);
    if (!w) return null;
    return { kind: 'fn', from: caret - w[0].length, prefix: w[0] };
}

export function completions(ctx, { props, fns }, limit = 8) {
    if (!ctx) return [];
    const p = ctx.prefix.toLowerCase();
    if (ctx.kind === 'prop') {
        return (props || []).filter((n) => n.toLowerCase().includes(p)).slice(0, limit)
            .map((n) => ({ label: n, insert: escapeName(n) + '")', kind: 'prop' }));
    }
    const list = [{ name: 'prop', sig: 'prop("…")' }].concat(fns || []);
    return list.filter((f) => f.name.toLowerCase().startsWith(p)).slice(0, limit)
        .map((f) => ({ label: f.name, insert: f.name === 'prop' ? 'prop("' : f.name + '(', kind: 'fn', sig: f.sig }));
}

export function applyCompletion(text, caret, ctx, item) {
    let end = caret;
    if (ctx.kind === 'prop') {
        // 이미 닫혀 있던 prop("…") 안이면 남은 이름 조각과 ") 를 먹는다
        const rest = text.slice(caret);
        const close = rest.indexOf('")');
        if (close >= 0 && !rest.slice(0, close).includes('"')) end = caret + close + 2;
    }
    const next = text.slice(0, ctx.from) + item.insert + text.slice(end);
    return { text: next, caret: ctx.from + item.insert.length };
}
